import {
  RESET_DASHBOARD_ASSETALLOCATION_REQUESTED,
  RESET_DASHBOARD_ASSETALLOCATION_COMPLETED,
} from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_DASHBOARD_ASSETALLOCATION_REQUESTED,
  });
  return dispatch({
    type: RESET_DASHBOARD_ASSETALLOCATION_COMPLETED,
  });
};

export default resetAction;
